import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable()
export class FileSaverService {
  saveFile(content: any, fileName: string, fileType: string) {
    saveAs(new Blob([content], { type: fileType }), fileName);
  }
}
